import { render, staticRenderFns } from "./CsWidgetChatEditor.vue?vue&type=template&id=30d638be&scoped=true&"
import script from "./CsWidgetChatEditor.vue?vue&type=script&lang=js&"
export * from "./CsWidgetChatEditor.vue?vue&type=script&lang=js&"
import style0 from "./CsWidgetChatEditor.vue?vue&type=style&index=0&id=30d638be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d638be",
  null
  
)

export default component.exports